// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1078":"5aed414f68d1700c7844","4813":"ab2b2002821df6001296","5157":"0aac1b571000f8d33706"}[chunkId] + ".css";
};